// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.4
// source: subscription.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.subscription";

export enum BillingFrequency {
  MONTHLY = 0,
  ANNUAL = 1,
  UNRECOGNIZED = -1,
}

export function billingFrequencyFromJSON(object: any): BillingFrequency {
  switch (object) {
    case 0:
    case "MONTHLY":
      return BillingFrequency.MONTHLY;
    case 1:
    case "ANNUAL":
      return BillingFrequency.ANNUAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BillingFrequency.UNRECOGNIZED;
  }
}

export function billingFrequencyToJSON(object: BillingFrequency): string {
  switch (object) {
    case BillingFrequency.MONTHLY:
      return "MONTHLY";
    case BillingFrequency.ANNUAL:
      return "ANNUAL";
    case BillingFrequency.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PlanGroup {
  DEFAULT = 0,
  ADMIN = 1,
  UNRECOGNIZED = -1,
}

export function planGroupFromJSON(object: any): PlanGroup {
  switch (object) {
    case 0:
    case "DEFAULT":
      return PlanGroup.DEFAULT;
    case 1:
    case "ADMIN":
      return PlanGroup.ADMIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlanGroup.UNRECOGNIZED;
  }
}

export function planGroupToJSON(object: PlanGroup): string {
  switch (object) {
    case PlanGroup.DEFAULT:
      return "DEFAULT";
    case PlanGroup.ADMIN:
      return "ADMIN";
    case PlanGroup.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SubscriptionStatus {
  CREATED = 0,
  AUTHORISED = 1,
  HOLD = 2,
  ACTIVE = 3,
  TRIAL = 4,
  PAUSED = 5,
  CANCELED = 6,
  COMPLETED = 7,
  UNRECOGNIZED = -1,
}

export function subscriptionStatusFromJSON(object: any): SubscriptionStatus {
  switch (object) {
    case 0:
    case "CREATED":
      return SubscriptionStatus.CREATED;
    case 1:
    case "AUTHORISED":
      return SubscriptionStatus.AUTHORISED;
    case 2:
    case "HOLD":
      return SubscriptionStatus.HOLD;
    case 3:
    case "ACTIVE":
      return SubscriptionStatus.ACTIVE;
    case 4:
    case "TRIAL":
      return SubscriptionStatus.TRIAL;
    case 5:
    case "PAUSED":
      return SubscriptionStatus.PAUSED;
    case 6:
    case "CANCELED":
      return SubscriptionStatus.CANCELED;
    case 7:
    case "COMPLETED":
      return SubscriptionStatus.COMPLETED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubscriptionStatus.UNRECOGNIZED;
  }
}

export function subscriptionStatusToJSON(object: SubscriptionStatus): string {
  switch (object) {
    case SubscriptionStatus.CREATED:
      return "CREATED";
    case SubscriptionStatus.AUTHORISED:
      return "AUTHORISED";
    case SubscriptionStatus.HOLD:
      return "HOLD";
    case SubscriptionStatus.ACTIVE:
      return "ACTIVE";
    case SubscriptionStatus.TRIAL:
      return "TRIAL";
    case SubscriptionStatus.PAUSED:
      return "PAUSED";
    case SubscriptionStatus.CANCELED:
      return "CANCELED";
    case SubscriptionStatus.COMPLETED:
      return "COMPLETED";
    case SubscriptionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PremiumFeature {
  category: string;
  subCategory: string;
  feature: string;
  featureCode: string;
  name: string;
  heading: string;
  description: string;
  mediaUrl?: string | undefined;
  priority: number;
}

export interface MediaUpload {
  data: Uint8Array;
  filename: string;
}

export interface PremiumFeatureUpsertRequest {
  category: string;
  subCategory: string;
  feature: string;
  featureCode: string;
  name: string;
  heading: string;
  description: string;
  priority: number;
  media?: MediaUpload | undefined;
  clearMedia?: boolean | undefined;
}

export interface SubscriptionFeatures {
  subscriptionPlan: string;
  premiumFeature: PremiumFeature[];
  isUserPlan: boolean;
  trialDays: number;
}

export interface SubscriptionFeatureResponse {
  subscriptionFeature: SubscriptionFeatures[];
}

export interface PremiumFeatureResponse {
  premiumFeature: PremiumFeature[];
}

export interface ManageFeatureRequest {
  subscriptionPlan: string[];
  featureCode: string;
}

export interface UserSubscriptionPlan {
  subscriptionPlan: string[];
}

export interface SubscriptionPlan {
  id: string;
  planGroup: PlanGroup;
  priority: number;
  features: string[];
  trialDays: number;
  gatewayPlanId: string;
  isActive: boolean;
  payments: PlanPayment[];
}

export interface PlanPayment {
  planId: string;
  billingFrequency: BillingFrequency;
  billingInterval: number;
  amount: number;
  discount: number;
  isActive: boolean;
}

export interface UserSubscription {
  id: string;
  gatewaySubscriptionId: string;
  planId: string;
  userId: string;
  status: SubscriptionStatus;
  startDate: number;
  currentStartDate: number;
  currentEndDate: number;
  lastBilledDate: number;
  message: string;
  plan: SubscriptionPlan | undefined;
  isTrial: boolean;
}

export interface SubscriptionPlansResponse {
  plans: SubscriptionPlan[];
}

export interface UserSubscriptionsResponse {
  subscriptions: UserSubscription[];
}

export interface CreateSubscriptionRequest {
  planId: string;
  billingFrequency: BillingFrequency;
  gatewaySubscriptionId: string;
}

export interface TrialEligibilityResponse {
  eligible: boolean;
  reason: string;
}

function createBasePremiumFeature(): PremiumFeature {
  return {
    category: "",
    subCategory: "",
    feature: "",
    featureCode: "",
    name: "",
    heading: "",
    description: "",
    mediaUrl: undefined,
    priority: 0,
  };
}

export const PremiumFeature = {
  encode(message: PremiumFeature, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.category !== "") {
      writer.uint32(10).string(message.category);
    }
    if (message.subCategory !== "") {
      writer.uint32(18).string(message.subCategory);
    }
    if (message.feature !== "") {
      writer.uint32(26).string(message.feature);
    }
    if (message.featureCode !== "") {
      writer.uint32(34).string(message.featureCode);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.heading !== "") {
      writer.uint32(50).string(message.heading);
    }
    if (message.description !== "") {
      writer.uint32(58).string(message.description);
    }
    if (message.mediaUrl !== undefined) {
      writer.uint32(66).string(message.mediaUrl);
    }
    if (message.priority !== 0) {
      writer.uint32(72).int32(message.priority);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PremiumFeature {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePremiumFeature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.category = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.subCategory = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.feature = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.featureCode = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.heading = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.description = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.mediaUrl = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.priority = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PremiumFeature {
    return {
      category: isSet(object.category) ? globalThis.String(object.category) : "",
      subCategory: isSet(object.subCategory) ? globalThis.String(object.subCategory) : "",
      feature: isSet(object.feature) ? globalThis.String(object.feature) : "",
      featureCode: isSet(object.featureCode) ? globalThis.String(object.featureCode) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      heading: isSet(object.heading) ? globalThis.String(object.heading) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      mediaUrl: isSet(object.mediaUrl) ? globalThis.String(object.mediaUrl) : undefined,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
    };
  },

  toJSON(message: PremiumFeature): unknown {
    const obj: any = {};
    if (message.category !== "") {
      obj.category = message.category;
    }
    if (message.subCategory !== "") {
      obj.subCategory = message.subCategory;
    }
    if (message.feature !== "") {
      obj.feature = message.feature;
    }
    if (message.featureCode !== "") {
      obj.featureCode = message.featureCode;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.heading !== "") {
      obj.heading = message.heading;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.mediaUrl !== undefined) {
      obj.mediaUrl = message.mediaUrl;
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PremiumFeature>, I>>(base?: I): PremiumFeature {
    return PremiumFeature.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PremiumFeature>, I>>(object: I): PremiumFeature {
    const message = createBasePremiumFeature();
    message.category = object.category ?? "";
    message.subCategory = object.subCategory ?? "";
    message.feature = object.feature ?? "";
    message.featureCode = object.featureCode ?? "";
    message.name = object.name ?? "";
    message.heading = object.heading ?? "";
    message.description = object.description ?? "";
    message.mediaUrl = object.mediaUrl ?? undefined;
    message.priority = object.priority ?? 0;
    return message;
  },
};

function createBaseMediaUpload(): MediaUpload {
  return { data: new Uint8Array(0), filename: "" };
}

export const MediaUpload = {
  encode(message: MediaUpload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    if (message.filename !== "") {
      writer.uint32(18).string(message.filename);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MediaUpload {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMediaUpload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.filename = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MediaUpload {
    return {
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
    };
  },

  toJSON(message: MediaUpload): unknown {
    const obj: any = {};
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MediaUpload>, I>>(base?: I): MediaUpload {
    return MediaUpload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MediaUpload>, I>>(object: I): MediaUpload {
    const message = createBaseMediaUpload();
    message.data = object.data ?? new Uint8Array(0);
    message.filename = object.filename ?? "";
    return message;
  },
};

function createBasePremiumFeatureUpsertRequest(): PremiumFeatureUpsertRequest {
  return {
    category: "",
    subCategory: "",
    feature: "",
    featureCode: "",
    name: "",
    heading: "",
    description: "",
    priority: 0,
    media: undefined,
    clearMedia: undefined,
  };
}

export const PremiumFeatureUpsertRequest = {
  encode(message: PremiumFeatureUpsertRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.category !== "") {
      writer.uint32(10).string(message.category);
    }
    if (message.subCategory !== "") {
      writer.uint32(18).string(message.subCategory);
    }
    if (message.feature !== "") {
      writer.uint32(26).string(message.feature);
    }
    if (message.featureCode !== "") {
      writer.uint32(34).string(message.featureCode);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.heading !== "") {
      writer.uint32(50).string(message.heading);
    }
    if (message.description !== "") {
      writer.uint32(58).string(message.description);
    }
    if (message.priority !== 0) {
      writer.uint32(64).int32(message.priority);
    }
    if (message.media !== undefined) {
      MediaUpload.encode(message.media, writer.uint32(74).fork()).ldelim();
    }
    if (message.clearMedia !== undefined) {
      writer.uint32(80).bool(message.clearMedia);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PremiumFeatureUpsertRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePremiumFeatureUpsertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.category = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.subCategory = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.feature = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.featureCode = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.heading = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.description = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.priority = reader.int32();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.priority = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.clearMedia = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PremiumFeatureUpsertRequest {
    return {
      category: isSet(object.category) ? globalThis.String(object.category) : "",
      subCategory: isSet(object.subCategory) ? globalThis.String(object.subCategory) : "",
      feature: isSet(object.feature) ? globalThis.String(object.feature) : "",
      featureCode: isSet(object.featureCode) ? globalThis.String(object.featureCode) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      heading: isSet(object.heading) ? globalThis.String(object.heading) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      media: isSet(object.media) ? MediaUpload.fromJSON(object.media) : undefined,
      clearMedia: isSet(object.clearMedia) ? globalThis.Boolean(object.clearMedia) : undefined,
    };
  },

  toJSON(message: PremiumFeatureUpsertRequest): unknown {
    const obj: any = {};
    if (message.category !== "") {
      obj.category = message.category;
    }
    if (message.subCategory !== "") {
      obj.subCategory = message.subCategory;
    }
    if (message.feature !== "") {
      obj.feature = message.feature;
    }
    if (message.featureCode !== "") {
      obj.featureCode = message.featureCode;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.heading !== "") {
      obj.heading = message.heading;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.media !== undefined) {
      obj.media = MediaUpload.toJSON(message.media);
    }
    if (message.clearMedia !== undefined) {
      obj.clearMedia = message.clearMedia;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PremiumFeatureUpsertRequest>, I>>(base?: I): PremiumFeatureUpsertRequest {
    return PremiumFeatureUpsertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PremiumFeatureUpsertRequest>, I>>(object: I): PremiumFeatureUpsertRequest {
    const message = createBasePremiumFeatureUpsertRequest();
    message.category = object.category ?? "";
    message.subCategory = object.subCategory ?? "";
    message.feature = object.feature ?? "";
    message.featureCode = object.featureCode ?? "";
    message.name = object.name ?? "";
    message.heading = object.heading ?? "";
    message.description = object.description ?? "";
    message.priority = object.priority ?? 0;
    message.media = (object.media !== undefined && object.media !== null)
      ? MediaUpload.fromPartial(object.media)
      : undefined;
    message.clearMedia = object.clearMedia ?? undefined;
    return message;
  },
};

function createBaseSubscriptionFeatures(): SubscriptionFeatures {
  return { subscriptionPlan: "", premiumFeature: [], isUserPlan: false, trialDays: 0 };
}

export const SubscriptionFeatures = {
  encode(message: SubscriptionFeatures, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.subscriptionPlan !== "") {
      writer.uint32(10).string(message.subscriptionPlan);
    }
    for (const v of message.premiumFeature) {
      PremiumFeature.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.isUserPlan !== false) {
      writer.uint32(24).bool(message.isUserPlan);
    }
    if (message.trialDays !== 0) {
      writer.uint32(32).int32(message.trialDays);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionFeatures {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionFeatures();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionPlan = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.premiumFeature.push(PremiumFeature.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isUserPlan = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.trialDays = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionFeatures {
    return {
      subscriptionPlan: isSet(object.subscriptionPlan) ? globalThis.String(object.subscriptionPlan) : "",
      premiumFeature: globalThis.Array.isArray(object?.premiumFeature)
        ? object.premiumFeature.map((e: any) => PremiumFeature.fromJSON(e))
        : [],
      isUserPlan: isSet(object.isUserPlan) ? globalThis.Boolean(object.isUserPlan) : false,
      trialDays: isSet(object.trialDays) ? globalThis.Number(object.trialDays) : 0,
    };
  },

  toJSON(message: SubscriptionFeatures): unknown {
    const obj: any = {};
    if (message.subscriptionPlan !== "") {
      obj.subscriptionPlan = message.subscriptionPlan;
    }
    if (message.premiumFeature?.length) {
      obj.premiumFeature = message.premiumFeature.map((e) => PremiumFeature.toJSON(e));
    }
    if (message.isUserPlan !== false) {
      obj.isUserPlan = message.isUserPlan;
    }
    if (message.trialDays !== 0) {
      obj.trialDays = Math.round(message.trialDays);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionFeatures>, I>>(base?: I): SubscriptionFeatures {
    return SubscriptionFeatures.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionFeatures>, I>>(object: I): SubscriptionFeatures {
    const message = createBaseSubscriptionFeatures();
    message.subscriptionPlan = object.subscriptionPlan ?? "";
    message.premiumFeature = object.premiumFeature?.map((e) => PremiumFeature.fromPartial(e)) || [];
    message.isUserPlan = object.isUserPlan ?? false;
    message.trialDays = object.trialDays ?? 0;
    return message;
  },
};

function createBaseSubscriptionFeatureResponse(): SubscriptionFeatureResponse {
  return { subscriptionFeature: [] };
}

export const SubscriptionFeatureResponse = {
  encode(message: SubscriptionFeatureResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.subscriptionFeature) {
      SubscriptionFeatures.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionFeatureResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionFeatureResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionFeature.push(SubscriptionFeatures.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionFeatureResponse {
    return {
      subscriptionFeature: globalThis.Array.isArray(object?.subscriptionFeature)
        ? object.subscriptionFeature.map((e: any) => SubscriptionFeatures.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SubscriptionFeatureResponse): unknown {
    const obj: any = {};
    if (message.subscriptionFeature?.length) {
      obj.subscriptionFeature = message.subscriptionFeature.map((e) => SubscriptionFeatures.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionFeatureResponse>, I>>(base?: I): SubscriptionFeatureResponse {
    return SubscriptionFeatureResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionFeatureResponse>, I>>(object: I): SubscriptionFeatureResponse {
    const message = createBaseSubscriptionFeatureResponse();
    message.subscriptionFeature = object.subscriptionFeature?.map((e) => SubscriptionFeatures.fromPartial(e)) || [];
    return message;
  },
};

function createBasePremiumFeatureResponse(): PremiumFeatureResponse {
  return { premiumFeature: [] };
}

export const PremiumFeatureResponse = {
  encode(message: PremiumFeatureResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.premiumFeature) {
      PremiumFeature.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PremiumFeatureResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePremiumFeatureResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.premiumFeature.push(PremiumFeature.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PremiumFeatureResponse {
    return {
      premiumFeature: globalThis.Array.isArray(object?.premiumFeature)
        ? object.premiumFeature.map((e: any) => PremiumFeature.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PremiumFeatureResponse): unknown {
    const obj: any = {};
    if (message.premiumFeature?.length) {
      obj.premiumFeature = message.premiumFeature.map((e) => PremiumFeature.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PremiumFeatureResponse>, I>>(base?: I): PremiumFeatureResponse {
    return PremiumFeatureResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PremiumFeatureResponse>, I>>(object: I): PremiumFeatureResponse {
    const message = createBasePremiumFeatureResponse();
    message.premiumFeature = object.premiumFeature?.map((e) => PremiumFeature.fromPartial(e)) || [];
    return message;
  },
};

function createBaseManageFeatureRequest(): ManageFeatureRequest {
  return { subscriptionPlan: [], featureCode: "" };
}

export const ManageFeatureRequest = {
  encode(message: ManageFeatureRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.subscriptionPlan) {
      writer.uint32(10).string(v!);
    }
    if (message.featureCode !== "") {
      writer.uint32(18).string(message.featureCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ManageFeatureRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManageFeatureRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionPlan.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.featureCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManageFeatureRequest {
    return {
      subscriptionPlan: globalThis.Array.isArray(object?.subscriptionPlan)
        ? object.subscriptionPlan.map((e: any) => globalThis.String(e))
        : [],
      featureCode: isSet(object.featureCode) ? globalThis.String(object.featureCode) : "",
    };
  },

  toJSON(message: ManageFeatureRequest): unknown {
    const obj: any = {};
    if (message.subscriptionPlan?.length) {
      obj.subscriptionPlan = message.subscriptionPlan;
    }
    if (message.featureCode !== "") {
      obj.featureCode = message.featureCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManageFeatureRequest>, I>>(base?: I): ManageFeatureRequest {
    return ManageFeatureRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManageFeatureRequest>, I>>(object: I): ManageFeatureRequest {
    const message = createBaseManageFeatureRequest();
    message.subscriptionPlan = object.subscriptionPlan?.map((e) => e) || [];
    message.featureCode = object.featureCode ?? "";
    return message;
  },
};

function createBaseUserSubscriptionPlan(): UserSubscriptionPlan {
  return { subscriptionPlan: [] };
}

export const UserSubscriptionPlan = {
  encode(message: UserSubscriptionPlan, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.subscriptionPlan) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSubscriptionPlan {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSubscriptionPlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionPlan.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSubscriptionPlan {
    return {
      subscriptionPlan: globalThis.Array.isArray(object?.subscriptionPlan)
        ? object.subscriptionPlan.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: UserSubscriptionPlan): unknown {
    const obj: any = {};
    if (message.subscriptionPlan?.length) {
      obj.subscriptionPlan = message.subscriptionPlan;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSubscriptionPlan>, I>>(base?: I): UserSubscriptionPlan {
    return UserSubscriptionPlan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSubscriptionPlan>, I>>(object: I): UserSubscriptionPlan {
    const message = createBaseUserSubscriptionPlan();
    message.subscriptionPlan = object.subscriptionPlan?.map((e) => e) || [];
    return message;
  },
};

function createBaseSubscriptionPlan(): SubscriptionPlan {
  return {
    id: "",
    planGroup: 0,
    priority: 0,
    features: [],
    trialDays: 0,
    gatewayPlanId: "",
    isActive: false,
    payments: [],
  };
}

export const SubscriptionPlan = {
  encode(message: SubscriptionPlan, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.planGroup !== 0) {
      writer.uint32(16).int32(message.planGroup);
    }
    if (message.priority !== 0) {
      writer.uint32(24).int32(message.priority);
    }
    for (const v of message.features) {
      writer.uint32(34).string(v!);
    }
    if (message.trialDays !== 0) {
      writer.uint32(40).int32(message.trialDays);
    }
    if (message.gatewayPlanId !== "") {
      writer.uint32(50).string(message.gatewayPlanId);
    }
    if (message.isActive !== false) {
      writer.uint32(56).bool(message.isActive);
    }
    for (const v of message.payments) {
      PlanPayment.encode(v!, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionPlan {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionPlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.planGroup = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.priority = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.features.push(reader.string());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.trialDays = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.gatewayPlanId = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.payments.push(PlanPayment.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionPlan {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      planGroup: isSet(object.planGroup) ? planGroupFromJSON(object.planGroup) : 0,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      features: globalThis.Array.isArray(object?.features) ? object.features.map((e: any) => globalThis.String(e)) : [],
      trialDays: isSet(object.trialDays) ? globalThis.Number(object.trialDays) : 0,
      gatewayPlanId: isSet(object.gatewayPlanId) ? globalThis.String(object.gatewayPlanId) : "",
      isActive: isSet(object.isActive) ? globalThis.Boolean(object.isActive) : false,
      payments: globalThis.Array.isArray(object?.payments)
        ? object.payments.map((e: any) => PlanPayment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SubscriptionPlan): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.planGroup !== 0) {
      obj.planGroup = planGroupToJSON(message.planGroup);
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.features?.length) {
      obj.features = message.features;
    }
    if (message.trialDays !== 0) {
      obj.trialDays = Math.round(message.trialDays);
    }
    if (message.gatewayPlanId !== "") {
      obj.gatewayPlanId = message.gatewayPlanId;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.payments?.length) {
      obj.payments = message.payments.map((e) => PlanPayment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionPlan>, I>>(base?: I): SubscriptionPlan {
    return SubscriptionPlan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionPlan>, I>>(object: I): SubscriptionPlan {
    const message = createBaseSubscriptionPlan();
    message.id = object.id ?? "";
    message.planGroup = object.planGroup ?? 0;
    message.priority = object.priority ?? 0;
    message.features = object.features?.map((e) => e) || [];
    message.trialDays = object.trialDays ?? 0;
    message.gatewayPlanId = object.gatewayPlanId ?? "";
    message.isActive = object.isActive ?? false;
    message.payments = object.payments?.map((e) => PlanPayment.fromPartial(e)) || [];
    return message;
  },
};

function createBasePlanPayment(): PlanPayment {
  return { planId: "", billingFrequency: 0, billingInterval: 0, amount: 0, discount: 0, isActive: false };
}

export const PlanPayment = {
  encode(message: PlanPayment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.planId !== "") {
      writer.uint32(10).string(message.planId);
    }
    if (message.billingFrequency !== 0) {
      writer.uint32(16).int32(message.billingFrequency);
    }
    if (message.billingInterval !== 0) {
      writer.uint32(24).int32(message.billingInterval);
    }
    if (message.amount !== 0) {
      writer.uint32(33).double(message.amount);
    }
    if (message.discount !== 0) {
      writer.uint32(41).double(message.discount);
    }
    if (message.isActive !== false) {
      writer.uint32(48).bool(message.isActive);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlanPayment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanPayment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.planId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.billingFrequency = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.billingInterval = reader.int32();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.amount = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.discount = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.isActive = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanPayment {
    return {
      planId: isSet(object.planId) ? globalThis.String(object.planId) : "",
      billingFrequency: isSet(object.billingFrequency) ? billingFrequencyFromJSON(object.billingFrequency) : 0,
      billingInterval: isSet(object.billingInterval) ? globalThis.Number(object.billingInterval) : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      discount: isSet(object.discount) ? globalThis.Number(object.discount) : 0,
      isActive: isSet(object.isActive) ? globalThis.Boolean(object.isActive) : false,
    };
  },

  toJSON(message: PlanPayment): unknown {
    const obj: any = {};
    if (message.planId !== "") {
      obj.planId = message.planId;
    }
    if (message.billingFrequency !== 0) {
      obj.billingFrequency = billingFrequencyToJSON(message.billingFrequency);
    }
    if (message.billingInterval !== 0) {
      obj.billingInterval = Math.round(message.billingInterval);
    }
    if (message.amount !== 0) {
      obj.amount = message.amount;
    }
    if (message.discount !== 0) {
      obj.discount = message.discount;
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanPayment>, I>>(base?: I): PlanPayment {
    return PlanPayment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanPayment>, I>>(object: I): PlanPayment {
    const message = createBasePlanPayment();
    message.planId = object.planId ?? "";
    message.billingFrequency = object.billingFrequency ?? 0;
    message.billingInterval = object.billingInterval ?? 0;
    message.amount = object.amount ?? 0;
    message.discount = object.discount ?? 0;
    message.isActive = object.isActive ?? false;
    return message;
  },
};

function createBaseUserSubscription(): UserSubscription {
  return {
    id: "",
    gatewaySubscriptionId: "",
    planId: "",
    userId: "",
    status: 0,
    startDate: 0,
    currentStartDate: 0,
    currentEndDate: 0,
    lastBilledDate: 0,
    message: "",
    plan: undefined,
    isTrial: false,
  };
}

export const UserSubscription = {
  encode(message: UserSubscription, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.gatewaySubscriptionId !== "") {
      writer.uint32(18).string(message.gatewaySubscriptionId);
    }
    if (message.planId !== "") {
      writer.uint32(26).string(message.planId);
    }
    if (message.userId !== "") {
      writer.uint32(34).string(message.userId);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.startDate !== 0) {
      writer.uint32(48).int64(message.startDate);
    }
    if (message.currentStartDate !== 0) {
      writer.uint32(56).int64(message.currentStartDate);
    }
    if (message.currentEndDate !== 0) {
      writer.uint32(64).int64(message.currentEndDate);
    }
    if (message.lastBilledDate !== 0) {
      writer.uint32(72).int64(message.lastBilledDate);
    }
    if (message.message !== "") {
      writer.uint32(82).string(message.message);
    }
    if (message.plan !== undefined) {
      SubscriptionPlan.encode(message.plan, writer.uint32(90).fork()).ldelim();
    }
    if (message.isTrial !== false) {
      writer.uint32(96).bool(message.isTrial);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSubscription {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSubscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.gatewaySubscriptionId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.planId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.startDate = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.currentStartDate = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.currentEndDate = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.lastBilledDate = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.message = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.plan = SubscriptionPlan.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.isTrial = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSubscription {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      gatewaySubscriptionId: isSet(object.gatewaySubscriptionId) ? globalThis.String(object.gatewaySubscriptionId) : "",
      planId: isSet(object.planId) ? globalThis.String(object.planId) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      status: isSet(object.status) ? subscriptionStatusFromJSON(object.status) : 0,
      startDate: isSet(object.startDate) ? globalThis.Number(object.startDate) : 0,
      currentStartDate: isSet(object.currentStartDate) ? globalThis.Number(object.currentStartDate) : 0,
      currentEndDate: isSet(object.currentEndDate) ? globalThis.Number(object.currentEndDate) : 0,
      lastBilledDate: isSet(object.lastBilledDate) ? globalThis.Number(object.lastBilledDate) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      plan: isSet(object.plan) ? SubscriptionPlan.fromJSON(object.plan) : undefined,
      isTrial: isSet(object.isTrial) ? globalThis.Boolean(object.isTrial) : false,
    };
  },

  toJSON(message: UserSubscription): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.gatewaySubscriptionId !== "") {
      obj.gatewaySubscriptionId = message.gatewaySubscriptionId;
    }
    if (message.planId !== "") {
      obj.planId = message.planId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.status !== 0) {
      obj.status = subscriptionStatusToJSON(message.status);
    }
    if (message.startDate !== 0) {
      obj.startDate = Math.round(message.startDate);
    }
    if (message.currentStartDate !== 0) {
      obj.currentStartDate = Math.round(message.currentStartDate);
    }
    if (message.currentEndDate !== 0) {
      obj.currentEndDate = Math.round(message.currentEndDate);
    }
    if (message.lastBilledDate !== 0) {
      obj.lastBilledDate = Math.round(message.lastBilledDate);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.plan !== undefined) {
      obj.plan = SubscriptionPlan.toJSON(message.plan);
    }
    if (message.isTrial !== false) {
      obj.isTrial = message.isTrial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSubscription>, I>>(base?: I): UserSubscription {
    return UserSubscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSubscription>, I>>(object: I): UserSubscription {
    const message = createBaseUserSubscription();
    message.id = object.id ?? "";
    message.gatewaySubscriptionId = object.gatewaySubscriptionId ?? "";
    message.planId = object.planId ?? "";
    message.userId = object.userId ?? "";
    message.status = object.status ?? 0;
    message.startDate = object.startDate ?? 0;
    message.currentStartDate = object.currentStartDate ?? 0;
    message.currentEndDate = object.currentEndDate ?? 0;
    message.lastBilledDate = object.lastBilledDate ?? 0;
    message.message = object.message ?? "";
    message.plan = (object.plan !== undefined && object.plan !== null)
      ? SubscriptionPlan.fromPartial(object.plan)
      : undefined;
    message.isTrial = object.isTrial ?? false;
    return message;
  },
};

function createBaseSubscriptionPlansResponse(): SubscriptionPlansResponse {
  return { plans: [] };
}

export const SubscriptionPlansResponse = {
  encode(message: SubscriptionPlansResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.plans) {
      SubscriptionPlan.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionPlansResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionPlansResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.plans.push(SubscriptionPlan.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionPlansResponse {
    return {
      plans: globalThis.Array.isArray(object?.plans) ? object.plans.map((e: any) => SubscriptionPlan.fromJSON(e)) : [],
    };
  },

  toJSON(message: SubscriptionPlansResponse): unknown {
    const obj: any = {};
    if (message.plans?.length) {
      obj.plans = message.plans.map((e) => SubscriptionPlan.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionPlansResponse>, I>>(base?: I): SubscriptionPlansResponse {
    return SubscriptionPlansResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionPlansResponse>, I>>(object: I): SubscriptionPlansResponse {
    const message = createBaseSubscriptionPlansResponse();
    message.plans = object.plans?.map((e) => SubscriptionPlan.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUserSubscriptionsResponse(): UserSubscriptionsResponse {
  return { subscriptions: [] };
}

export const UserSubscriptionsResponse = {
  encode(message: UserSubscriptionsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.subscriptions) {
      UserSubscription.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSubscriptionsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSubscriptionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptions.push(UserSubscription.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSubscriptionsResponse {
    return {
      subscriptions: globalThis.Array.isArray(object?.subscriptions)
        ? object.subscriptions.map((e: any) => UserSubscription.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserSubscriptionsResponse): unknown {
    const obj: any = {};
    if (message.subscriptions?.length) {
      obj.subscriptions = message.subscriptions.map((e) => UserSubscription.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSubscriptionsResponse>, I>>(base?: I): UserSubscriptionsResponse {
    return UserSubscriptionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSubscriptionsResponse>, I>>(object: I): UserSubscriptionsResponse {
    const message = createBaseUserSubscriptionsResponse();
    message.subscriptions = object.subscriptions?.map((e) => UserSubscription.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateSubscriptionRequest(): CreateSubscriptionRequest {
  return { planId: "", billingFrequency: 0, gatewaySubscriptionId: "" };
}

export const CreateSubscriptionRequest = {
  encode(message: CreateSubscriptionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.planId !== "") {
      writer.uint32(10).string(message.planId);
    }
    if (message.billingFrequency !== 0) {
      writer.uint32(16).int32(message.billingFrequency);
    }
    if (message.gatewaySubscriptionId !== "") {
      writer.uint32(26).string(message.gatewaySubscriptionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateSubscriptionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.planId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.billingFrequency = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.gatewaySubscriptionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSubscriptionRequest {
    return {
      planId: isSet(object.planId) ? globalThis.String(object.planId) : "",
      billingFrequency: isSet(object.billingFrequency) ? billingFrequencyFromJSON(object.billingFrequency) : 0,
      gatewaySubscriptionId: isSet(object.gatewaySubscriptionId) ? globalThis.String(object.gatewaySubscriptionId) : "",
    };
  },

  toJSON(message: CreateSubscriptionRequest): unknown {
    const obj: any = {};
    if (message.planId !== "") {
      obj.planId = message.planId;
    }
    if (message.billingFrequency !== 0) {
      obj.billingFrequency = billingFrequencyToJSON(message.billingFrequency);
    }
    if (message.gatewaySubscriptionId !== "") {
      obj.gatewaySubscriptionId = message.gatewaySubscriptionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSubscriptionRequest>, I>>(base?: I): CreateSubscriptionRequest {
    return CreateSubscriptionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSubscriptionRequest>, I>>(object: I): CreateSubscriptionRequest {
    const message = createBaseCreateSubscriptionRequest();
    message.planId = object.planId ?? "";
    message.billingFrequency = object.billingFrequency ?? 0;
    message.gatewaySubscriptionId = object.gatewaySubscriptionId ?? "";
    return message;
  },
};

function createBaseTrialEligibilityResponse(): TrialEligibilityResponse {
  return { eligible: false, reason: "" };
}

export const TrialEligibilityResponse = {
  encode(message: TrialEligibilityResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eligible !== false) {
      writer.uint32(8).bool(message.eligible);
    }
    if (message.reason !== "") {
      writer.uint32(18).string(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrialEligibilityResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrialEligibilityResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eligible = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.reason = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrialEligibilityResponse {
    return {
      eligible: isSet(object.eligible) ? globalThis.Boolean(object.eligible) : false,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: TrialEligibilityResponse): unknown {
    const obj: any = {};
    if (message.eligible !== false) {
      obj.eligible = message.eligible;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrialEligibilityResponse>, I>>(base?: I): TrialEligibilityResponse {
    return TrialEligibilityResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrialEligibilityResponse>, I>>(object: I): TrialEligibilityResponse {
    const message = createBaseTrialEligibilityResponse();
    message.eligible = object.eligible ?? false;
    message.reason = object.reason ?? "";
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
